/* eslint-disable no-alert */
import React, { useContext, useState, useEffect } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  Alert,
  Platform,
  Dimensions,
} from "react-native";
import { useColorScheme } from "react-native-appearance";
import { colors } from "../context/Colors";
import AppContext from "../context";
import GameDescription from "./GameDescription";
import Icon from "react-native-vector-icons/Ionicons";
// import { useNavigation } from "@react-navigation/native";
import GameFooter from "./GameFooter";
import { isTablet } from "react-native-device-info";

const calcSize = () => {
  const width = Dimensions.get("screen").width;
  if (width > 700) {
    return width / 4 - 30;
  } else {
    return width / 2 - 30;
  }
};

export default function TakePhoto({ g, current }) {
  const theme = useColorScheme() === "dark" ? "dark" : "light";
  const { tour, resolveURL, dict } = useContext(AppContext);
  // const navigation = useNavigation();
  const size = calcSize();

  const artifacts = tour.inventory.filter(
    (v) => v.enablePhotoWithObject && v.objectType === "Object"
  );

  let possibleArtifacts = 0;
  tour.stops.forEach((s) => {
    s.challenges.forEach((c) => {
      if (c.objectType === "Object" && c.enablePhotoWithObject)
        possibleArtifacts++;
    });
  });
  const emptyArtifacts = new Array(possibleArtifacts - artifacts.length);

  const takePhoto = (a) => {
    if (g.state === "failed" || g.state === "correct") {
    } else {
      // navigation.navigate("Camera", {
      //   artifact: a,
      //   g,
      // });
    }
  };
  // console.log(artifacts);

  const insertFakeBoxes = () => {
    const fakes = new Array((emptyArtifacts.length + artifacts.length) % 4);
    if (isTablet())
      return (
        <>
          {fakes.fill(null).map((f, k) => (
            <View key={k} style={{ width: size }} />
          ))}
        </>
      );
    return null;
  };

  if (Platform.OS === "web")
    return (
      <Text
        style={{
          fontSize: 18,
          fontWeight: "bold",
          color: colors[theme].text,
          marginTop: 30,
          textAlign: "center",
        }}
      >
        {dict.photo_not_supported}
      </Text>
    );

  return (
    <View>
      <GameDescription g={g} current={current} />
      <Text
        style={{
          fontSize: 18,
          fontWeight: "bold",
          color: colors[theme].text,
          marginTop: 30,
        }}
      >
        {g.enablePhotoWithObject
          ? dict.select_an_artifact
          : dict.take_a_picture}
      </Text>
      <Text
        style={{
          marginTop: 10,
          fontSize: 16,
          color: colors[theme].text,
          opacity: 0.7,
        }}
      >
        {g.question}
      </Text>
      <GameFooter g={g} />
      <View style={{ height: 30 }} />
      {g.enablePhotoWithObject ? (
        <View
          style={{
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          {artifacts.map((a, k) => (
            <TouchableOpacity
              key={k}
              style={{
                borderRadius: 10,
                padding: 16,
                shadowColor: "#000",
                shadowOffset: {
                  width: 0,
                  height: 0,
                },
                shadowOpacity: 0.1,
                shadowRadius: 6.27,
                elevation: 4,
                marginBottom: 20,
                flexDirection: "row",
                alignItems: "center",
                backgroundColor: colors[theme].bg,
              }}
              onPress={() => takePhoto(a)}
            >
              <Image
                source={{
                  uri: resolveURL("game", a.objectBlobReference, 200),
                }}
                style={{
                  width: size - 30,
                  height: size - 30,
                }}
                resizeMode={"contain"}
              />
            </TouchableOpacity>
          ))}
          {emptyArtifacts.fill(null).map((a, k) => (
            <TouchableOpacity
              key={k}
              onPress={() =>
                Alert.alert(dict.error, dict.artifact_not_collected)
              }
            >
              <View
                style={{
                  width: size,
                  height: size,
                  borderRadius: 8,
                  backgroundColor: colors[theme].buttonBorder,
                  opacity: 0.7,
                  marginBottom: 20,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Text
                  style={{
                    fontSize: 80,
                    color: colors[theme].text,
                    opacity: 0.1,
                    fontWeight: "bold",
                  }}
                >
                  ?
                </Text>
              </View>
            </TouchableOpacity>
          ))}
          {insertFakeBoxes()}
        </View>
      ) : (
        <View style={{ justifyContent: "center", alignItems: "center" }}>
          <TouchableOpacity
            style={{
              borderRadius: 4,
              padding: 12,
              marginBottom: 20,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              borderColor: colors[theme].gray2,
              borderWidth: 2,
              display: g.state === "correct" ? "none" : "flex",
              width: size * 2 + 20,
            }}
            onPress={() => takePhoto()}
            disabled={g.state === "correct"}
          >
            <Icon name="camera-outline" size={30} color={colors[theme].text} />
            <Text
              style={{
                color: colors[theme].text,
                fontWeight: "500",
                marginLeft: 7,
                fontSize: 18,
              }}
            >
              {dict.take_a_photo}
            </Text>
          </TouchableOpacity>
        </View>
      )}
      <View style={{ height: 60 }} />
    </View>
  );
}
